import React, { FC } from 'react'

import { IconType } from '../../common/types'

const NucLogout: FC<IconType> = ({
  iconColor = 'currentColor',
  ...svgProps
}) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 19 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...svgProps}
    >
      <path
        d='M5.625 13.875H3.375C2.74219 13.875 2.25 13.3828 2.25 12.75V3.75C2.25 3.15234 2.74219 2.625 3.375 2.625H5.625C6.22266 2.625 6.75 2.13281 6.75 1.5C6.75 0.902344 6.22266 0.375 5.625 0.375H3.375C1.47656 0.375 0 1.88672 0 3.75V12.75C0 14.6484 1.47656 16.125 3.375 16.125H5.625C6.22266 16.125 6.75 15.6328 6.75 15C6.75 14.4023 6.22266 13.875 5.625 13.875ZM17.6484 7.47656L13.1484 2.97656C12.7266 2.51953 11.9883 2.51953 11.5664 2.97656C11.1094 3.39844 11.1094 4.13672 11.5664 4.55859L14.1328 7.125H6.75C6.11719 7.125 5.625 7.65234 5.625 8.25C5.625 8.88281 6.11719 9.375 6.75 9.375H14.1328L11.5664 11.9766C11.1094 12.3984 11.1094 13.1367 11.5664 13.5586C11.9883 14.0156 12.7266 14.0156 13.1484 13.5586L17.6484 9.05859C18.1055 8.63672 18.1055 7.89844 17.6484 7.47656Z'
        fill={iconColor}
      />
    </svg>
  )
}

export default NucLogout
